import { render, staticRenderFns } from "./TypeConfig.vue?vue&type=template&id=420ef703&"
import script from "./TypeConfig.vue?vue&type=script&lang=ts&"
export * from "./TypeConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports